import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectAllTimesFromState} from '../../../shared/stores/root-store/selectors/video.selector';
import {TimerType} from '../../../../enums/timer-type.enum';
import VideoState from '../../../shared/stores/root-store/video.state';
import * as moment from 'moment';

@Component({
    selector: 'eocm-timer',
    templateUrl: './timer.component.html',
    styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {

    @Input() type;
    public timeToDisplay;
    public totalTime = 0;

    constructor(private store: Store<{ video: VideoState }>) {
    }

    ngOnInit() {
        this.store.select(selectAllTimesFromState)
            .subscribe(({totalTime, currentTime}) => {
                this.totalTime = totalTime;
                this.convertSecondsToRepresentativeFormat(currentTime);
            });
    }

    convertSecondsToRepresentativeFormat(seconds: number) {
        seconds = this.roundNegativeValue(seconds);

        if (this.type === TimerType.Decrement) {
            this.timeToDisplay = this.convertSecondsToDisplayFormat(this.roundNegativeValue(this.totalTime - seconds));
        } else if (this.type === TimerType.Increment) {
            this.timeToDisplay = this.convertSecondsToDisplayFormat(seconds);
        } else {
            this.timeToDisplay = this.convertSecondsToDisplayFormat(this.roundNegativeValue(this.totalTime));
        }
    }

    convertSecondsToDisplayFormat(seconds: number) {
        const format = seconds >= 3600 ? 'H:mm:ss' : 'm:ss';
        return (moment as any).utc((moment as any).duration(seconds, 'seconds').asMilliseconds()).format(format);
    }

    private roundNegativeValue(value): number {
        return value < 0 ? 0 : value;
    }

}
